import React from 'react'

// Lightweight, dependency-free "Aceternity"-style animated background beams
// Uses CSS keyframes defined in src/styles/site.css
const BackgroundBeams = ({ className = '' }) => {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
      <div className="beam beam-1" />
      <div className="beam beam-2" />
      <div className="beam beam-3" />
    </div>
  )
}

export default BackgroundBeams

